import { Gender as GenderApi } from "generated/api";

const Gender = {
  [GenderApi.M]: "Male",
  [GenderApi.F]: "Female",
  [GenderApi.U]: "Prefer not to say",
} as const;

export default Gender;
